import { c as cn } from "./cn-BHs2eMrl.js";
const semanticKeys = ["default", "primary", "success", "warning", "attention", "danger", "purple", "sky", "danger-dark"];
const variantKeys = ["default", "contained", "surface", "outlined"];
const sizeKeys = ["default", "condensed", "md", "sm"];
const textVariants = {
  default: "text-gray-11",
  primary: "text-primary-11",
  success: "text-success-11",
  danger: "text-danger-11",
  warning: "text-warning-11",
  attention: "text-attention-11",
  purple: "text-accessory-purple-11",
  sky: "text-accessory-sky-11",
  "danger-dark": "text-danger-11"
};
const textHoverVariants = {
  default: "hover:text-gray-12",
  primary: "hover:text-primary-11",
  success: "hover:text-success-12",
  danger: "hover:text-danger-12",
  warning: "hover:text-warning-12",
  attention: "hover:text-attention-12",
  purple: "hover:text-accessory-purple-12",
  sky: "hover:text-accessory-sky-12",
  "danger-dark": "hover:text-danger-12"
};
const textOnVariants = {
  default: "data-[state=on]:text-gray-11",
  primary: "data-[state=on]:text-primary-11",
  success: "data-[state=on]:text-success-11",
  danger: "data-[state=on]:text-danger-11",
  warning: "data-[state=on]:text-warning-11",
  attention: "data-[state=on]:text-attention-11",
  purple: "data-[state=on]:text-accessory-purple-11",
  sky: "data-[state=on]:text-accessory-sky-11",
  "danger-dark": "data-[state=on]:text-danger-11"
};
const textForegroundVariants = {
  default: "text-white ",
  primary: "text-white",
  success: "text-white",
  danger: "text-white",
  warning: "text-white",
  attention: "text-attention-11",
  purple: "text-white",
  sky: "text-accessory-sky-11",
  "danger-dark": "text-white"
};
const textForegroundHoverVariants = {
  default: "hover:text-white",
  primary: "hover:text-white",
  success: "hover:text-white",
  danger: "hover:text-white",
  warning: "hover:text-white",
  attention: "hover:text-attention-11",
  purple: "hover:text-white",
  sky: "hover:text-accessory-sky-11",
  "danger-dark": "hover:text-white"
};
const textForegroundOnVariants = {
  default: "data-[state=on]:text-white",
  primary: "data-[state=on]:text-white",
  success: "data-[state=on]:text-white",
  danger: "data-[state=on]:text-white",
  warning: "data-[state=on]:text-white",
  attention: "data-[state=on]:text-attention-11",
  purple: "data-[state=on]:text-white",
  sky: "data-[state=on]:text-accessory-sky-11",
  "danger-dark": "data-[state=on]:text-white"
};
const borderVariants = {
  default: "border-gray-7",
  primary: "border-primary-7",
  success: "border-success-7",
  warning: "border-warning-7",
  attention: "border-attention-7",
  danger: "border-danger-7",
  purple: "border-accessory-purple-7",
  sky: "border-accessory-sky",
  "danger-dark": "border-danger-11"
};
const borderHoverVariants = {
  default: "hover:border-gray-8",
  primary: "hover:border-primary-8",
  success: "hover:border-success-8",
  danger: "hover:border-danger-8",
  warning: "hover:border-warning-8",
  attention: "hover:border-attention-8",
  purple: "hover:border-accessory-purple-8",
  sky: "hover:border-accessory-sky-8",
  "danger-dark": "hover:border-danger-12"
};
const borderOnVariants = {
  default: "data-[state=on]:border-gray-9",
  primary: "data-[state=on]:border-primary-9",
  success: "data-[state=on]:border-success-9",
  danger: "data-[state=on]:border-danger-9",
  warning: "data-[state=on]:border-warning-9",
  attention: "data-[state=on]:border-attention-9",
  purple: "data-[state=on]:border-accessory-purple-9",
  sky: "data-[state=on]:border-accessory-sky-9",
  "danger-dark": "data-[state=on]:border-danger-11"
};
const borderActiveVariants = {
  default: "active:border-gray-9",
  primary: "active:border-primary-9",
  success: "active:border-success-9",
  danger: "active:border-danger-9",
  warning: "active:border-warning-9",
  attention: "active:border-attention-9",
  purple: "active:border-accessory-purple-9",
  sky: "active:border-accessory-sky-9",
  "danger-dark": "active:border-danger-11"
};
const backgroundSolidVariants = {
  default: "bg-gray",
  primary: "bg-primary",
  success: "bg-success",
  danger: "bg-danger",
  warning: "bg-warning",
  attention: "bg-attention",
  purple: "bg-accessory-purple",
  sky: "bg-accessory-sky",
  "danger-dark": "bg-danger-11"
};
const backgroundSolidOnVariants = {
  default: "data-[state=on]:bg-gray",
  primary: "data-[state=on]:bg-primary",
  success: "data-[state=on]:bg-success",
  danger: "data-[state=on]:bg-danger",
  warning: "data-[state=on]:bg-warning",
  attention: "data-[state=on]:bg-attention",
  purple: "data-[state=on]:bg-accessory-purple",
  sky: "data-[state=on]:bg-accessory-sky",
  "danger-dark": "data-[state=on]:bg-danger-11"
};
const backgroundSolidActiveVariants = {
  default: "active:bg-gray-11",
  primary: "active:bg-primary-12",
  success: "active:bg-success-11",
  danger: "active:bg-danger-11",
  warning: "active:bg-warning-11",
  attention: "active:bg-attention-11 active:text-attention-4",
  purple: "active:bg-accessory-purple-11 ",
  sky: "active:bg-accessory-sky-11 active:text-accessory-sky-4",
  "danger-dark": "active:bg-danger-12"
};
const backgroundSolidHoverVariants = {
  default: "hover:bg-gray-10",
  primary: "hover:bg-primary-10",
  success: "hover:bg-success-10",
  danger: "hover:bg-danger-10",
  warning: "hover:bg-warning-10",
  attention: "hover:bg-attention-10",
  purple: "hover:bg-accessory-purple-10",
  sky: "hover:bg-accessory-sky-10",
  "danger-dark": "hover:bg-danger-12"
};
const backgroundSurfaceVariants = {
  default: "bg-gray-3 border border-gray-4",
  primary: "bg-primary-3 border border-primary-4",
  success: "bg-success-3 border border-success-4",
  danger: "bg-danger-3 border border-danger-4",
  warning: "bg-warning-3 border border-warning-4",
  attention: "bg-attention-3 border border-attention-4",
  purple: "bg-accessory-purple-3 border border-accessory-purple-4",
  sky: "bg-accessory-sky-3 border border-accessory-sky-4",
  "danger-dark": "bg-danger-4 border border-danger-4"
};
const backgroundSurfaceHoverVariants = {
  default: "hover:bg-gray-4 hover:border-gray-8",
  primary: "hover:bg-primary-4 hover:border-primary-8",
  success: "hover:bg-success-4 hover:border-success-8",
  danger: "hover:bg-danger-4 hover:border-danger-8",
  warning: "hover:bg-warning-4 hover:border-warning-8",
  attention: "hover:bg-attention-4 hover:border-attention-8",
  purple: "hover:bg-accessory-purple-4 hover:border-accessory-purple-8",
  sky: "hover:bg-accessory-sky-4 hover:border-accessory-sky-8",
  "danger-dark": "hover:bg-danger-4 hover:border-danger-8"
};
const backgroundSurfaceOnVariants = {
  default: "data-[state=on]:bg-gray-3",
  primary: "data-[state=on]:bg-primary-3",
  success: "data-[state=on]:bg-success-3",
  danger: "data-[state=on]:bg-danger-3",
  warning: "data-[state=on]:bg-warning-3",
  attention: "data-[state=on]:bg-attention-3",
  purple: "data-[state=on]:bg-accessory-purple-3",
  sky: "data-[state=on]:bg-accessory-sky-3",
  "danger-dark": "data-[state=on]:bg-danger-3"
};
const backgroundSurfaceActiveVariants = {
  default: "active:bg-gray-5",
  primary: "active:bg-primary-5",
  success: "active:bg-success-5",
  danger: "active:bg-danger-5",
  warning: "active:bg-warning-5",
  attention: "active:bg-attention-5",
  purple: "active:bg-accessory-purple-5",
  sky: "active:bg-accessory-sky-5",
  "danger-dark": "active:bg-danger-5"
};
const backgroundSurfaceOpenVariants = {
  default: "data-[state=open]:bg-gray-4 data-[state=open]:border-gray-6 data-[state=open]:border data-[state=open]:text-gray-10",
  primary: "data-[state=open]:bg-primary-4 data-[state=open]:border-primary-6 data-[state=open]:border data-[state=open]:text-primary-10",
  success: "data-[state=open]:bg-success-4 data-[state=open]:border-success-6 data-[state=open]:border data-[state=open]:text-success-10",
  danger: "data-[state=open]:bg-danger-4 data-[state=open]:border-danger-6 data-[state=open]:border data-[state=open]:text-danger-10",
  warning: "data-[state=open]:bg-warning-4 data-[state=open]:border-warning-6 data-[state=open]:border data-[state=open]:text-warning-10",
  attention: "data-[state=open]:bg-attention-4 data-[state=open]:border-attention-6 data-[state=open]:border data-[state=open]:text-attention-10",
  purple: "data-[state=open]:bg-accessory-purple-4 data-[state=open]:border-accessory-purple-6 data-[state=open]:border data-[state=open]:text-accessory-purple-10",
  sky: "data-[state=open]:bg-accessory-sky-4 data-[state=open]:border-accessory-sky-6 data-[state=open]:border data-[state=open]:text-accessory-sky-10",
  "danger-dark": "data-[state=open]:bg-danger-4 data-[state=open]:border-danger-6 data-[state=open]:border data-[state=open]:text-danger-10"
};
const positionVariants = {
  top: "top-0 inset-x-1/2 -translate-y-1/2 -translate-x-1/2",
  bottom: "bottom-0 inset-x-1/2 translate-y-1/2 -translate-x-1/2",
  left: "left-0 inset-y-1/2 -translate-x-1/2 -translate-y-1/2",
  right: "right-0 inset-y-1/2 translate-x-1/2 -translate-y-1/2",
  "top-right": "top-0 right-0 -translate-y-1/2 translate-x-1/2",
  "top-left": "top-0 left-0 -translate-y-1/2 -translate-x-1/2",
  "bottom-right": "bottom-0 right-0 translate-y-1/2 translate-x-1/2",
  "bottom-left": "bottom-0 left-0 translate-y-1/2 -translate-x-1/2"
};
const variantVariants = {
  default: cn(backgroundSurfaceVariants.default, textVariants.default),
  contained: cn(backgroundSolidVariants.default, textVariants.default),
  surface: cn(backgroundSurfaceVariants.default, textVariants.default),
  outlined: cn("border", borderVariants.default, textVariants.default)
};
const containedCompoundVariants = semanticKeys.map((key) => ({
  variant: "contained",
  color: key,
  className: cn(backgroundSolidVariants[key], textForegroundVariants[key])
}));
const surfaceCompoundVariants = semanticKeys.map((key) => ({
  variant: "surface",
  color: key,
  className: cn(backgroundSurfaceVariants[key], textVariants[key])
}));
const outlinedCompoundVariants = semanticKeys.map((key) => ({
  variant: "outlined",
  color: key,
  className: cn("border", borderVariants[key], textVariants[key])
}));
const ghostCompoundVariants = semanticKeys.map((key) => ({
  variant: "ghost",
  color: key,
  className: cn(textVariants[key])
}));
const textCompoundVariants = semanticKeys.map((key) => ({
  variant: "text",
  color: key,
  className: cn(textVariants[key], textHoverVariants[key], backgroundSurfaceHoverVariants[key])
}));
const dotCompoundVariants = semanticKeys.map((key) => ({
  variant: "dot",
  color: key,
  className: backgroundSolidVariants[key]
}));
const sharedVariants = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  backgroundSolidActiveVariants,
  backgroundSolidHoverVariants,
  backgroundSolidOnVariants,
  backgroundSolidVariants,
  backgroundSurfaceActiveVariants,
  backgroundSurfaceHoverVariants,
  backgroundSurfaceOnVariants,
  backgroundSurfaceOpenVariants,
  backgroundSurfaceVariants,
  borderActiveVariants,
  borderHoverVariants,
  borderOnVariants,
  borderVariants,
  containedCompoundVariants,
  dotCompoundVariants,
  ghostCompoundVariants,
  outlinedCompoundVariants,
  positionVariants,
  semanticKeys,
  sizeKeys,
  surfaceCompoundVariants,
  textCompoundVariants,
  textForegroundHoverVariants,
  textForegroundOnVariants,
  textForegroundVariants,
  textHoverVariants,
  textOnVariants,
  textVariants,
  variantKeys,
  variantVariants
}, Symbol.toStringTag, { value: "Module" }));
export {
  backgroundSurfaceOnVariants as a,
  borderOnVariants as b,
  backgroundSolidOnVariants as c,
  textForegroundOnVariants as d,
  backgroundSurfaceOpenVariants as e,
  borderHoverVariants as f,
  backgroundSurfaceHoverVariants as g,
  backgroundSolidHoverVariants as h,
  textVariants as i,
  textHoverVariants as j,
  textForegroundHoverVariants as k,
  borderActiveVariants as l,
  backgroundSolidActiveVariants as m,
  backgroundSurfaceActiveVariants as n,
  containedCompoundVariants as o,
  borderVariants as p,
  outlinedCompoundVariants as q,
  surfaceCompoundVariants as r,
  sharedVariants as s,
  textOnVariants as t,
  ghostCompoundVariants as u,
  textCompoundVariants as v,
  semanticKeys as w,
  backgroundSurfaceVariants as x,
  variantVariants as y
};
